export default customElements.define('w-field-datebox', class FieldDatebox extends wealthify.componentBases.FieldText {
    
    #maxDate = '9999-12-31';

    constructor() {
        super();

        this.onConnectedCallback = () => {
            this.dom.fieldinput.type = 'date';
            this[wealthify.FieldValidation.validationPropEnums.Max] = this[wealthify.FieldValidation.validationPropEnums.Max] ??  this.#maxDate;
        };
    }
    
    get readOnlyWidth () {
        return '7rem';
    }

    static styleSelector = 'c-field-datebox';
    static validationProps = [
        wealthify.FieldValidation.validationPropEnums.Min,
        wealthify.FieldValidation.validationPropEnums.Max,
    ]

    static get formatEnums() {
        return { Over18: 'over-18' };
    }

    static get formatDictionary() {

        return {[this.formatEnums.Over18]: {
            'type': 'date',
            [wealthify.FieldValidation.validationPropEnums.Min]: this.#convertDateToDateString(150),
            [wealthify.FieldValidation.validationPropEnums.Max]: this.#convertDateToDateString(18),
            [wealthify.FieldValidation.messagePropEnums.Min]: 'Woah, are you sure? That makes you the oldest person on earth!',
            [wealthify.FieldValidation.messagePropEnums.Max]: 'You must be 18 or over to continue',
        }};
    }

    static #convertDateToDateString(yearsAgo) {
        const date = new Date();

        date.setFullYear(date.getFullYear() - yearsAgo);

        return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + (date.getDate())).slice(-2)}`;
    }
});